var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsEnum, IsOptional, IsString, MaxLength, } from 'class-validator';
import { DriverLicenseType } from '../../../enums';
import { CreateReservationPersonDto } from './create-reservation-person.dto';
export class ValidateReservationDriverLicenseAndUpdateDto extends CreateReservationPersonDto {
}
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "driverLicenseNumber", void 0);
__decorate([
    IsString(),
    MaxLength(32),
    __metadata("design:type", String)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "name", void 0);
__decorate([
    IsEnum(DriverLicenseType),
    __metadata("design:type", String)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "driverLicenseType", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "skipDriverLicenseValidation", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ValidateReservationDriverLicenseAndUpdateDto.prototype, "passAmbiguousDriverExperience", void 0);
